import { z } from 'zod/v4';
import { FilterSchema } from '../query/schema.js';
import { ViewVisibilityType } from './visibility.js';
export const AugmentedFilterSchema = FilterSchema.and(z.object({
    id: z.uuid(),
    filterKey: z.string(),
}));
export const ViewDescriptionSchema = z.object({
    base: z.string(),
    displayOptions: z.array(z.string()),
    filters: z.array(AugmentedFilterSchema),
    orderBy: z.string(),
    orderByDirection: z.enum(['ASC', 'DESC']).optional(),
});
export const CreateViewSchema = z.object({
    id: z.uuid().optional(),
    name: z.string(),
    options: ViewDescriptionSchema,
    visibility: z.enum(ViewVisibilityType),
});
export const UpdateViewSchema = z.object({
    name: z.string().optional(),
    options: ViewDescriptionSchema.optional(),
    visibility: z.enum(ViewVisibilityType).optional(),
});
//# sourceMappingURL=index.js.map